export default __webpack_public_path__ + "static/media/video.22bd43e5.mp4";